<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.account" placeholder="手机号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getUsers">查询</el-button>
				</el-form-item>
				<!--<el-form-item>
					<el-button type="primary" @click="handleAdd">导出</el-button>
				</el-form-item>-->
			</el-form>
		</el-col>

		<!--列表-->
		<el-table @sort-change='sortion' :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<!--<el-table-column type="selection" width="55">
			</el-table-column>-->
			<el-table-column type="index" width="40">
			</el-table-column>
			<!--<el-table-column type="openId" width="60">
			</el-table-column>-->
			<el-table-column prop="user_name" label="用户昵称" width="160" sortable>
			</el-table-column>
			<!--<el-table-column prop="phone_number" label="所属设备编号" width="150" sortable>
			</el-table-column>-->
			<el-table-column prop="gender" label="性别" width="80" :formatter="formatSex" sortable>
			</el-table-column>
			<!--<el-table-column prop="age" label="年龄" width="100" sortable>
			</el-table-column>-->
			<el-table-column prop="phone_number" label="手机号" width="150" sortable>
			</el-table-column>
			<el-table-column prop="linkTime" label="最后连接时间" width="250" sortable>
			</el-table-column>
			<el-table-column label="操作" min-width="300">
				<template slot-scope="scope">
					<el-button :type="scope.row.white?'warning':'primary'" size="small" @click="changeWhite(scope.$index, scope.row)" plain>{{scope.row.white?'取消白名单':'设为白名单'}}</el-button>
					<el-button :type="scope.row.red?'warning':'primary'" size="small" @click="changeRed(scope.$index, scope.row)" plain>{{scope.row.red?'取消测试人员':'设为测试人员'}}</el-button>
					<el-button :type="scope.row.assign_power?'warning':'primary'" size="small" @click="changeAssign(scope.$index, scope.row)" plain>{{scope.row.assign_power?'取消分配权限':'添加分配权限'}}</el-button>
					<el-button v-if="GLOBAL.organ_sysno==GLOBAL.adminSysno.adminOrgan" :type="scope.row.create_power?'warning':'primary'" size="small" @click="changeCreate(scope.$index, scope.row)" plain>{{scope.row.create_power?'取消创建权限':'添加创建权限'}}</el-button>
					<!--<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>-->
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除{{addFormVisible}}</el-button>-->
			<el-pagination layout="prev, pager, next,jumper"  @current-change="handleCurrentChange"  :page-size="size" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { getUserList, removeOrgan, batchRemoveUser  , deleteWhite, addWhite   ,deleteRed, addRed   ,deleteCreatePower,addCreatePower   ,deleteAssignPower,addAssignPower } from '../api/api';

	export default {
		data() {
			return {
				filters: {
					account: ''
				},
				users: [],
				total:2,
				sort:'desc',
				page: 1,
				size:10,
				listLoading: false,
				sels: [],//列表选中列
				dialogFormVisible: false,
				form: {
			        name: '',
			        region: '',
			        date1: '',
			        date2: '',
			        delivery: false,
			        type: [],
			        resource: '',
			        desc: ''
		        },
		        formLabelWidth: '120px',
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入公司名称', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					name: '',
					sysno: '',
					upper_sysno: '',
					password: '',
					account: ''
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入公司名称', trigger: 'blur' },
					],
				},
				//新增界面数据
				addForm: {
					name: '',
					upper_sysno:'',
					account: '',
					password: '',
				}

			}
		},
		props:['organ_sysno'],
		methods: {
			//排序
			sortion(row){
				this.prop=row.prop
				switch(row.order){
					case 'descending':
						this.sort='desc'
					break;
					case 'ascending':
						this.sort='asc'
					break;
				}
				this.getUsers()
			},
			//性别显示转换
			formatSex: function (row, column) {
				return row.gender == 1 ? '男' : row.gender == 0 ? '女' : '未知';
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page = val;
				this.getUsers();
			},
			changeWhite(a,b){
				let para={
						white_sysno:b.white,
						openid:b.openId,
						organ_sysno:this.GLOBAL.organ_sysno
					}
				if(!!b.white){
					deleteWhite(para).then((res)=>{
						this.getUsers();
						console.log(res)
					})
				}else{
					addWhite(para).then((res)=>{
						this.getUsers();
						console.log(res)
					})
				}
			},
			changeRed(a,b){
				let para={
						red_sysno:b.red,
						openid:b.openId,
						organ_sysno:this.GLOBAL.organ_sysno
					}
				if(!!b.red){
					deleteRed(para).then((res)=>{
						this.getUsers();
						console.log(res)
					})
				}else{
					addRed(para).then((res)=>{
						this.getUsers();
						console.log(res)
					})
				}
			},
			changeAssign(a,b){
				let para={
						assign_power:b.assign_power,
						openid:b.openId,
						organ_sysno:this.GLOBAL.organ_sysno
					}
				console.log(b,'b')
				console.log(para)
				if(b.assign_power){
					deleteAssignPower(para).then((res)=>{
						this.getUsers();
						console.log(res)
					})
				}else{
					addAssignPower(para).then((res)=>{
						this.getUsers();
						console.log(res)
					})
				}
			},
			changeCreate(a,b){
				let para={
					create_power:b.create_power,
					openid:b.openId,
					organ_sysno:this.GLOBAL.organ_sysno
				}
				console.log(b,'b')
				console.log(para)
				if(b.create_power){
					deleteCreatePower(para).then((res)=>{
						this.getUsers();
						console.log(res)
					})
				}else{
					addCreatePower(para).then((res)=>{
						this.getUsers();
						console.log(res)
					})
				}
			},
			//获取用户列表
			getUsers() {
				var that=this
				let para = {
					sort:this.sort,
					phoneNumber:this.filters.account.trim(),
					organ_sysno:this.GLOBAL.organ_sysno,
					pageNo:this.page,
					pageSize:this.size,
				};
				this.listLoading = true;
				//NProgress.start();
				getUserList(para).then((res) => {
					console.log(res)
					that.total = res.data.data.rowcount;
					that.users = res.data.data.list;
					that.listLoading = false;
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { sysno: row.sysno };
					removeOrgan(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getUsers();
					});
				}).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm.sysno=row.sysno
				this.editForm.name=row.name
				this.editForm.account=row.account
				this.editForm.password=row.password
				this.editForm.upper_sysno=row.upper_sysno
				console.log('editForm',this.editForm)
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					name: '',
					upper_sysno: '',
					account: '',
					password:'',
//					addr: ''
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认修改吗？', '提示', {}).then(() => {
							console.log(valid)
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							//para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							editUser(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getUsers();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						console.log(valid)
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							console.log(this.addForm)
							let para = Object.assign({}, this.addForm);
							console.log(para)
//							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							addUser(para).then((res) => {
								console.log(res)
								this.addLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								this.getUsers();
							});
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getUsers();
					});
				}).catch(() => {

				});
			}
		},
		mounted() {
			this.getUsers();
		}
	}

</script>

<style lang="scss" slot-scope>

</style>


// WEBPACK FOOTER //
// src/components/user.vue